// Centralized amount formatting utility
// Formats a numeric amount in Israeli new shekel (ILS) with Arabic RTL locale
// Example output will include the shekel sign (₪) and Arabic digits, depending on Intl support

export function formatAmount(value, options = {}) {
  try {
    const n = Number(value);
    if (!Number.isFinite(n)) return String(value);

    const baseOptions = {
      style: 'currency',
      currency: 'ILS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      ...options,
    };

    // Prefer Arabic (Israel) for RTL and Arabic digits; fallbacks are acceptable.
    const locale = 'en-US';
    const formatter = new Intl.NumberFormat(locale, baseOptions);
    return formatter.format(n);
  } catch {
    // Fallback: manual symbol prefix with a basic number formatter in Arabic
    try {
      const num = new Intl.NumberFormat('ar', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
        Number(value) || 0
      );
      return `₪\u00A0${num}`; // add non-breaking space between symbol and number
    } catch {
      return `₪ ${String(value)}`;
    }
  }
}
